import { render, staticRenderFns } from "./masked-input.vue?vue&type=template&id=37d3f964&"
import script from "./masked-input.js?vue&type=script&lang=js&"
export * from "./masked-input.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports